import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { ButtonModule } from '../../common/button/button.module';
import { GroupModule } from './../../common/group/group.module';
import { RtUIFormsModule } from './../../forms/forms.module';
import { ListSortableFormComponent } from './list-sortable-form.component';

@NgModule({
  declarations: [ListSortableFormComponent],
  exports: [ListSortableFormComponent],
  imports: [RtUIFormsModule, GroupModule, I18nModule, ButtonModule],
})
export class ListSortableFormModule {}
export { ListSortableFormComponent } from './list-sortable-form.component';
